"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/**
 * 本组件仅用于收集用户的数据信息，实际渲染为 Menu.Item，不会用到
 * @param props
 * @constructor
 */
var SubMenu = function SubMenu(props) {
  var children = props.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
SubMenu.displayName = 'SubMenu';
var _default = exports.default = SubMenu;